/* member-invite.js — pilote le formulaire d'invitation membre.
 *
 * Contexte (SPEC-0006) : le formulaire déclare form_type=customer. Shopify n'en
 * retient que l'e-mail et le consentement marketing — le pays choisi est jeté et
 * aucun e-mail n'est envoyé. Ce script rétablit la chaîne :
 *
 *   1. restreint le <select> pays aux pays qui ont réellement un lien
 *      d'invitation, et n'affiche le sélecteur de langue que là où il tranche ;
 *   2. écrit le choix dans contact[tags] — c'est le seul canal que Shopify
 *      conserve, et c'est ce que Shopify Flow lira pour envoyer l'e-mail ;
 *   3. mémorise le choix avant l'envoi, pour afficher le bon lien au retour.
 *
 * L'affichage immédiat du lien est un filet : si l'e-mail se perd ou tarde, la
 * personne a déjà son lien à l'écran.
 *
 * Dépend de assets/member-invite-links.js (généré, window.MEMBER_INVITE_LINKS).
 */
(function () {
  'use strict';

  var DATA = window.MEMBER_INVITE_LINKS;
  if (!DATA) return;

  var STORE_KEY = 'nbs:member-invite';

  // Index valeur du <select> Shopify → slug de pays.
  var BY_VALUE = {};
  Object.keys(DATA).forEach(function (slug) {
    BY_VALUE[DATA[slug].value] = slug;
  });

  function langsOf(slug) {
    var entry = DATA[slug];
    if (!entry) return [];
    return Object.keys(entry.sprachen).sort(function (a, b) {
      return entry.sprachen[a].label.localeCompare(entry.sprachen[b].label);
    });
  }

  function linkFor(slug, lang) {
    var entry = DATA[slug];
    if (!entry) return null;
    var langs = Object.keys(entry.sprachen);
    // Une seule langue : pas de choix à faire, on la prend.
    if (!lang && langs.length === 1) lang = langs[0];
    var hit = lang && entry.sprachen[lang];
    return hit ? hit.link : null;
  }

  function remember(slug, lang) {
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify({ land: slug, sprache: lang }));
    } catch (e) { /* navigation privée : on perd juste le filet d'affichage */ }
  }

  function recall() {
    try {
      return JSON.parse(sessionStorage.getItem(STORE_KEY) || 'null');
    } catch (e) { return null; }
  }

  /* ---- écran de confirmation : afficher le lien tout de suite ------------ */

  function renderSuccess(box) {
    var choice = recall();
    if (!choice) return;
    var link = linkFor(choice.land, choice.sprache);
    if (!link) return;

    var label = box.getAttribute('data-invite-cta') || 'Zur Anmeldung';
    var a = document.createElement('a');
    a.className = 'btn member-invite__link';
    a.href = link;
    a.target = '_blank';
    a.rel = 'noopener';
    a.textContent = label;

    var wrap = document.createElement('p');
    wrap.className = 'member-invite__link-wrap';
    wrap.appendChild(a);
    box.appendChild(wrap);

    try { sessionStorage.removeItem(STORE_KEY); } catch (e) {}
  }

  /* ---- formulaire -------------------------------------------------------- */

  function wire(langWrap) {
    // On part du bloc langue et on remonte au formulaire : le tag Liquid
    // {% form %} n'accepte pas d'attribut à tiret, donc pas de marqueur posable
    // sur l'élément <form> lui-même.
    var form = langWrap.closest('form');
    if (!form || form.dataset.inviteWired) return;
    var country = form.querySelector('.country-select');
    var lang = langWrap.querySelector('select');
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (!country || !lang || !tags) return;
    form.dataset.inviteWired = '1';

    var baseTags = (tags.value || 'prospect,newsletter')
      .split(',')
      .map(function (t) { return t.trim(); })
      .filter(function (t) { return t && t.indexOf('einladung-') !== 0; });

    // Un pays sans lien d'invitation n'a rien à faire dans la liste : la
    // personne s'inscrirait pour ne rien recevoir.
    Array.prototype.slice.call(country.options).forEach(function (opt) {
      if (opt.value && opt.value !== '---' && !BY_VALUE[opt.value]) opt.remove();
    });

    function refresh() {
      var slug = BY_VALUE[country.value];
      var langs = langsOf(slug);

      lang.options.length = 0;
      if (langs.length > 1) {
        var ph = new Option(lang.getAttribute('data-placeholder') || 'Sprache*', '');
        ph.disabled = true; ph.selected = true;
        lang.appendChild(ph);
      }
      langs.forEach(function (code) {
        lang.appendChild(new Option(DATA[slug].sprachen[code].label, code));
      });

      // Le sélecteur ne s'affiche que lorsqu'il tranche vraiment : sur les
      // 22 pays livrés, 20 ont plusieurs langues, 2 n'en ont qu'une.
      var needed = langs.length > 1;
      langWrap.hidden = !needed;
      lang.required = needed;
      if (langs.length === 1) lang.value = langs[0];

      syncTags();
    }

    function syncTags() {
      var slug = BY_VALUE[country.value];
      var out = baseTags.slice();
      if (slug) {
        out.push('einladung-land-' + slug);
        if (lang.value) out.push('einladung-sprache-' + lang.value);
      }
      tags.value = out.join(',');
    }

    country.addEventListener('change', refresh);
    lang.addEventListener('change', syncTags);
    form.addEventListener('submit', function () {
      remember(BY_VALUE[country.value], lang.value);
    });

    refresh();
  }

  function init() {
    document.querySelectorAll('[data-invite-success]').forEach(renderSuccess);
    document.querySelectorAll('[data-invite-language]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
